// Mui
import { Grid2 } from "@mui/material";
//styling
import styles from "./Auth.module.scss";
// Icons
import { ReactComponent as Logo } from "../../GlobalAssets/svg/Logo.svg";
import LoginIllustration from "../../GlobalAssets/PNG/NewLogin.png";

export default function NewAuth({ component: PageComponent, ...rest }) {
  const appConfig = JSON.parse(localStorage.getItem("appConfig") || "{}");
  const appLogo = appConfig.logo;

  return (
    <>
      <Grid2 className={styles.PageContainer}>
        <Grid2 className={styles.image}>
          <img src={LoginIllustration} className={styles.loginImg} />
        </Grid2>
        <Grid2 className={styles.logo}>
          <img src={appLogo} alt="App Logo" className={styles.applogo} />
        </Grid2>
        <Grid2 className={styles.layoutContainer}>
          <Grid2 className={styles.Container}>
            <PageComponent />
          </Grid2>
        </Grid2>
      </Grid2>
    </>
  );
}
